import { menuItems } from "@peracto/peracto";
import { faAward } from "@fortawesome/pro-regular-svg-icons/faAward";
import { faTools } from "@fortawesome/pro-regular-svg-icons/faTools";

const ROLE_ADMIN = "ROLE_ADMIN";

export const menu = {
    ...menuItems,
    warrantyRegistrations: {
        label: "Warranty Registrations",
        icon: faAward,
        path: "/warranty-registrations",
        sortOrder: 75,
        roles: [ROLE_ADMIN],
    },
    testHarnesses: {
        label: "Test Harnesses",
        icon: faTools,
        sortOrder: 72,
        roles: [ROLE_ADMIN],
        children: {
            getEbsOrderPayload: {
                label: "Get EBS Order Payload",
                sortOrder: 10,
                roles: [ROLE_ADMIN],
                path: "/test-harnesses/ebs-order-payload",
            },
        },
    },
};
